import { LearnByDoingLink } from './LearnByDoingLink';
import { WatchOnHubSpotAcademyLink } from './WatchOnHubSpotAcademyLink';
import { usageTracker } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoWatermarkCTA = ({
  hasLearnByDoing,
  learnByDoingHref,
  link,
  openLinksInNewTab,
  renderContext,
  onClick,
  trackAction,
  contentId,
  lessonId,
  shortId
}) => {
  const linkType = hasLearnByDoing ? 'learn-by-doing' : 'watch-on-academy';
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick(linkType);
    usageTracker.track('interaction', {
      action: trackAction,
      contentId,
      lessonId,
      linkType,
      shortId
    });
  };
  return hasLearnByDoing ? /*#__PURE__*/_jsx(LearnByDoingLink, {
    href: learnByDoingHref,
    onClick: handleClick,
    openLinksInNewTab: openLinksInNewTab,
    renderContext: renderContext
  }) : /*#__PURE__*/_jsx(WatchOnHubSpotAcademyLink, {
    href: link,
    onClick: handleClick,
    openLinksInNewTab: openLinksInNewTab,
    renderContext: renderContext,
    truncate: false
  });
};